/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import { stub as $t } from '@nbcnews/analytics-framework';
import { CopyToClipboardButton } from 'components/CopyToClipboardButton';
import styles from './styles.module.scss';

$t('register', 'mbt_producttease_click', { allowDuplicate: true });

/**
 * PromoCode
 * @param {object} props
 * @param {string} props.promoCode
 * @param {boolean} props.isLarge
 * @param {string} [props.text]
 * @param {string} [props.startsAt]
 * @param {string} [props.endsAt]
 */
function PromoCode(props) {
  const {
    promoCode,
    isLarge = false,
    text = '',
    startsAt = '',
    endsAt = '',
  } = props;

  // if date range is provided, hide if current date is outside of range
  const now = new Date();
  const startDate = startsAt ? new Date(startsAt) : null;
  const endDate = endsAt ? new Date(endsAt) : null;

  if (startDate && now < startDate) {
    return null;
  }

  if (endDate && now > endDate) {
    return null;
  }

  // restyled to allow wrapping of promo code if there is extra text
  const variant = text ? 'product' : 'waffle';
  const isProductVariant = variant === 'product';

  const promoCodeIcon = (
    <svg
      className={classNames(styles.promoCodeIcon, {
        [styles.wrapped]: isProductVariant,
      })}
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="18"
      viewBox="0 0 10 18"
      fill="none"
    >
      <path
        d="M0 6.13446L5 1.49744L10 6.13446V18.4999H0V6.13446Z"
        className={styles.promoCodeIconShape}
      />
      <path
        d="M5.75854 4.09228C5.75854 4.51101 5.41909 4.85046 5.00036 4.85046C4.58163 4.85046 4.24219 4.51101 4.24219 4.09228C4.24219 3.67355 4.58163 3.33411 5.00036 3.33411C5.41909 3.33411 5.75854 3.67355 5.75854 4.09228Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.65128 16.9542C4.55346 16.9542 4.47335 16.8819 4.46626 16.7903L4.46574 16.7771L4.4657 15.9567C4.28468 15.9272 4.10889 15.8834 3.93825 15.8251C3.7345 15.7556 3.56635 15.6852 3.43386 15.614C3.30131 15.5429 3.17872 15.467 3.06609 15.3863L3.01996 15.3531C2.93946 15.2945 2.88095 15.2491 2.84439 15.2169L2.835 15.2084C2.79357 15.1705 2.76457 15.142 2.74801 15.1231C2.69167 15.0566 2.68837 14.9918 2.7381 14.9285L3.24997 14.2881C3.27314 14.2565 3.31127 14.2375 3.36427 14.2312C3.41395 14.2249 3.45373 14.2391 3.48355 14.2739L3.49351 14.2834C3.86789 14.5965 4.27042 14.7941 4.70119 14.8764C4.82379 14.9016 4.94637 14.9143 5.06896 14.9143C5.33731 14.9143 5.5734 14.8463 5.77716 14.7103C5.98091 14.5743 6.08281 14.3814 6.08281 14.1316C6.08281 14.043 6.05794 13.9592 6.00825 13.8801C5.95857 13.8011 5.90305 13.7347 5.84176 13.6809C5.78046 13.6271 5.68356 13.5678 5.55102 13.503L5.44778 13.4531C5.36057 13.4116 5.28568 13.3776 5.22303 13.3512L5.16578 13.3276C5.08201 13.2937 4.96859 13.2501 4.82544 13.197L4.48023 13.0631C4.42446 13.0411 4.35656 13.0132 4.27648 12.9793L4.21414 12.9527C4.08495 12.8974 3.98139 12.8483 3.90354 12.8056C3.82568 12.763 3.73209 12.7068 3.62276 12.6372C3.51343 12.5676 3.42479 12.5004 3.35689 12.4356C3.28894 12.3708 3.21691 12.2933 3.1407 12.2032C3.0645 12.113 3.00568 12.0213 2.96426 11.928C2.92283 11.8347 2.88805 11.7295 2.85988 11.6125C2.83176 11.4955 2.81767 11.3722 2.81767 11.2425C2.81767 10.8061 2.97999 10.4234 3.30468 10.0944C3.60703 9.78816 3.99405 9.58335 4.46585 9.47999V8.63012C4.46585 8.53229 4.54892 8.453 4.65139 8.453H5.40196C5.44834 8.453 5.48647 8.46724 5.51629 8.49572L5.5222 8.50165L5.52772 8.50788C5.55954 8.53963 5.57906 8.58268 5.57906 8.63012V9.44172L5.62375 9.4467C5.79045 9.467 5.95261 9.50108 6.11015 9.54885C6.28743 9.60261 6.43153 9.65558 6.54255 9.70779C6.65353 9.75997 6.75874 9.81924 6.85811 9.88566L6.91723 9.92555C6.97756 9.96669 7.02017 9.99732 7.04498 10.0175L7.05194 10.0233C7.08176 10.0485 7.10658 10.0707 7.12645 10.0897C7.17905 10.1428 7.18974 10.1987 7.15862 10.2573L6.74877 10.9625C6.72225 11.01 6.68417 11.0353 6.63448 11.0385C6.58805 11.0479 6.54336 11.0369 6.50028 11.0052L6.49019 10.9963C6.47746 10.9857 6.45676 10.9697 6.4282 10.9483L6.40481 10.9314C6.36573 10.9042 6.30892 10.8679 6.23441 10.8226C6.1433 10.7672 6.04636 10.7166 5.94368 10.6708C5.84095 10.6249 5.71754 10.5838 5.57342 10.5474C5.42928 10.5111 5.28764 10.4929 5.14849 10.4929C4.83376 10.4929 4.57697 10.5609 4.37817 10.6969C4.17937 10.8329 4.08 11.0084 4.08 11.2235C4.08 11.3057 4.09409 11.3816 4.12221 11.4512C4.15038 11.5208 4.19924 11.5864 4.26884 11.648C4.3384 11.7097 4.40387 11.7619 4.46516 11.8046C4.52133 11.8437 4.60397 11.8882 4.71303 11.938L4.83976 11.9941C4.90036 12.0205 4.95387 12.0432 5.00016 12.0621L5.07924 12.0934C5.14801 12.1201 5.24134 12.155 5.35924 12.1982L5.56429 12.2728C5.65819 12.3073 5.73492 12.3363 5.79456 12.3596L5.83972 12.3778C5.92684 12.4135 6.03769 12.4628 6.17224 12.5257C6.3313 12.6 6.45636 12.6672 6.54749 12.7273C6.6386 12.7874 6.74128 12.8665 6.85562 12.9645C6.96991 13.0625 7.05771 13.163 7.11901 13.2657C7.1803 13.3685 7.23247 13.4895 7.27555 13.6287C7.31863 13.7678 7.34014 13.9164 7.34014 14.0746C7.34014 14.5585 7.17534 14.9751 6.84565 15.3246C6.51979 15.67 6.09764 15.8849 5.57921 15.9692L5.57908 16.777C5.57908 16.8192 5.56365 16.8579 5.53791 16.8883L5.52778 16.8993C5.52422 16.9035 5.52039 16.9075 5.51631 16.9114C5.48649 16.9399 5.44836 16.9541 5.40198 16.9541L4.65128 16.9542Z"
        fill="white"
      />
    </svg>
  );

  // TODO: analytics team has provided both mbt_producttease_click and mbt_spotlightode_click events. Follow up to implemnt spotlightode version
  /**
   * Handles the click event for the promo code button.
   * Tracks the event using the `$t` function with the specified action.
   */
  const handlePromoCodeClick = () => {
    $t('track', 'mbt_producttease_click', {
      action: 'Promo code copied',
      promoCode,
    });
  };

  const copyButton = (
    <CopyToClipboardButton
      buttonText={promoCode}
      buttonClasses={classNames(styles.promoText, {
        [styles.isLarge]: isLarge,
        [styles.wrapped]: isProductVariant,
      })}
      copiedText={promoCode?.toUpperCase()}
      textAreaSelector="#product-waffle-clipboard"
      tooltipText="Code Copied!"
      handleClick={isProductVariant ? handlePromoCodeClick : undefined}
    />
  );

  return (
    <div className={classNames(styles.promoContainer, {
      [styles.wrapped]: isProductVariant,
    })}
    >
      {promoCodeIcon}
      <div
        className={classNames(styles.mainText, {
          [styles.wrapped]: isProductVariant,
          [styles.isLarge]: isLarge,
        })}
      >
        {isProductVariant ? 'USE PROMO CODE ' : 'PROMO CODE'}
      </div>
      <div className={classNames(styles.promoCodeContainer, {
        [styles.wrapped]: isProductVariant,
      })}
      >
        {copyButton}
      </div>
      {text && isProductVariant && (
        <span className={`${styles.mainText} ${styles.wrapped}`}>
          {' '}
          {text}
        </span>
      )}
    </div>
  );
}

export { PromoCode };
